// extracted by mini-css-extract-plugin
export default {"root":"Brand__root___xa5bx","connection":"Brand__connection___XQta2"};